import React from 'react';
import { FieldArray, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';

import { addOutletListForm, setItemDetail } from 'actions/businessLibrary/item';
import styles from './ItemForm.css';
import TooltipComponent from './Tooltip';
import OutletCheckBox from './OutletCheckbox';

class ItemForm extends React.Component {
  render() {
    const {
      isSalesTypePrice,
      itemVariantCustom,
      outletList,
      addOutlet,
    } = this.props;
    return (
      <div
        ref={a => {
          this.scrollArea = a;
        }}
        className={`${styles['item-fieldset']}`}
      >
        <div className={`row ${styles['item-form-right-container']}`}>
          <div className="col-lg-12 col-md-12 col-sm-12 no-padding-left no-padding-right">
            <div className="row">
              <div className="col-lg-12">
                <div className={`${styles['mb-0']}`}>
                  <span>OUTLETS</span>
                  <TooltipComponent
                    content={
                      'select the outlet you want to assign the item into'
                    }
                  />
                </div>
              </div>
            </div>

            <div className={styles['item-form-right-outlet-container']}>
              <div
                className={`${styles['item-form-section']} ${
                  styles['item-form-padding-top-10']
                }`}
              >
                <a
                  className={styles['item-form-button-deselect']}
                  onClick={this._selectUnselectAllOutlet}
                >
                  {this._getButtonName()}
                </a>
                <div className={`${styles['mb-0']}`}>
                  <span>Edit Price</span>
                  <TooltipComponent
                    content={'modify price of the item for particular outlets'}
                  />
                </div>
              </div>
              <FieldArray
                name={'item_outlets'}
                component={OutletCheckBox}
                type="checkbox"
                outletList={outletList}
                isSalesTypePrice={isSalesTypePrice}
                itemVariantCustom={itemVariantCustom}
                addOutlet={addOutlet}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }

  _getButtonName = () => {
    return this._isSomeDeselect() ? 'Select All' : 'Deselect All';
  };

  _isSomeDeselect = () => {
    const { itemVariantCustom } = this.props;
    return itemVariantCustom.some(item => !item.selected_outlet);
  };

  _selectUnselectAllOutlet = () => {
    if (this._isSomeDeselect()) {
      this._selectAllOutlet();
    } else {
      this._unselectAllOutlet();
    }
  };

  _selectAllOutlet = () => {
    const { itemVariantCustom, change, itemDetail, setItemDetail } = this.props;

    itemVariantCustom.map((_, idx) => {
      change('itemHub', `item_outlets[${idx}].selected_outlet`, true);
    });
    itemDetail.item_outlets.forEach(outlet => {
      outlet.selected_outlet = true;
    });
    setItemDetail(itemDetail);
  };

  _unselectAllOutlet = () => {
    const { itemVariantCustom, change, itemDetail, setItemDetail } = this.props;
    itemVariantCustom.map((_, idx) => {
      change('itemHub', `item_outlets[${idx}].selected_outlet`, false);
    });
    itemDetail.item_outlets.forEach(outlet => {
      outlet.selected_outlet = false;
    });
    setItemDetail(itemDetail);
  };
}

const selector = formValueSelector('itemHub');

const mapDispatchToProps = {
  addOutlet: addOutletListForm,
  setItemDetail,
  change,
};

function mapStateToProps(state) {
  const { outlets, outletList, itemDetail } = state.businessLibrary.itemHub;

  return {
    itemDetail,
    outlets,
    outletList,
    isSalesTypePrice: selector(state, 'is_sales_type_price'),
    itemVariantCustom: selector(state, 'item_outlets'),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ItemForm);
